/* Loyal Meet · comportamiento del tema
   1) Colores: agrupa productos hermanos por nombre (el último término del título es el color)
      y muestra puntos de color + "N colores" en tarjetas y el selector de color en producto. */
(function () {
  var COLOR_HEX = {
    NEGRO: '#111111', NEGRA: '#111111', BLACK: '#111111',
    BLANCO: '#FFFFFF', BLANCA: '#FFFFFF', WHITE: '#FFFFFF',
    MARFIL: '#EFE7D6', CREMA: '#F1E6CF', BEIGE: '#D8C6A5', HUESO: '#EEE6D6',
    CAFE: '#6B4A2F', 'CAFÉ': '#6B4A2F', TIERRA: '#8A5A3B', CAMEL: '#B08050',
    GRIS: '#9B9B9B', GIRS: '#9B9B9B', PLATA: '#C0C0C0',
    ROSADO: '#EBB5C3', ROSADA: '#EBB5C3', ROSA: '#EBB5C3', FUCSIA: '#D6246E',
    AMARILLO: '#F2CF45', AMARILLA: '#F2CF45',
    VERDE: '#3E5B32', OLIVA: '#6B6B3A',
    AZUL: '#2F4FA0', NAVY: '#1E2A44', CELESTE: '#9CC7E8',
    MORADO: '#7D5BA6', MORADA: '#7D5BA6', LILA: '#B9A3E3', PURPURA: '#6B3FA0',
    ROJO: '#C8102E', ROJA: '#C8102E', VINOTINTO: '#6D1A2A', BURDEOS: '#6D1A2A',
    NARANJA: '#E87A2D', MULTICOLOR: 'conic-gradient(#e33,#fc3,#3c6,#39f,#c3f,#e33)'
  };
  var MULTI_WORD = ['WASH BLUE', 'DIRTY CLEAR', 'AZUL WASH', 'GRIS WASH', 'ROSADO WASH', 'AMARILLO WASH'];

  function norm(s) { return (s || '').toString().trim().toUpperCase().replace(/\s+/g, ' '); }
  function split(title) {
    var t = norm(title);
    for (var i = 0; i < MULTI_WORD.length; i++) {
      var mw = MULTI_WORD[i];
      if (t.slice(-mw.length) === mw && t.length > mw.length) return { base: t.slice(0, -mw.length).trim(), color: mw };
    }
    var parts = t.split(' ');
    if (parts.length < 2) return { base: t, color: '' };
    return { base: parts.slice(0, -1).join(' '), color: parts[parts.length - 1] };
  }
  function hexFor(color) {
    var words = norm(color).split(' ');
    for (var i = 0; i < words.length; i++) { if (COLOR_HEX[words[i]]) return COLOR_HEX[words[i]]; }
    return '#CFCFCF';
  }

  var cache = null;
  function loadProducts() {
    if (cache) return cache;
    cache = new Promise(function (resolve) {
      var all = [];
      function page(n) {
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'products.json?limit=250&page=' + n)
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var list = (d && d.products) || [];
            all = all.concat(list);
            if (list.length === 250 && n < 6) page(n + 1); else resolve(all);
          })
          .catch(function () { resolve(all); });
      }
      page(1);
    });
    return cache;
  }
  function groups(products) {
    var g = {};
    products.forEach(function (p) {
      var s = split(p.title);
      if (!s.color) return;
      (g[s.base] = g[s.base] || []).push({ handle: p.handle, title: p.title, color: s.color, available: p.variants.some(function (v) { return v.available; }) });
    });
    return g;
  }
  function colorName(c) { return c.charAt(0) + c.slice(1).toLowerCase(); }

  function renderCards(g) {
    document.querySelectorAll('[data-lm-colors]:not([data-lm-done])').forEach(function (el) {
      el.setAttribute('data-lm-done', '1');
      var s = split(el.getAttribute('data-lm-title'));
      var sib = g[s.base] || [];
      if (sib.length < 2) return;
      var html = '<span class="lm-dots">';
      sib.slice(0, 5).forEach(function (x) {
        var cur = x.handle === el.getAttribute('data-lm-colors');
        html += '<a href="/products/' + x.handle + '" class="lm-dot' + (cur ? ' is-current' : '') + '" style="background:' + hexFor(x.color) + '" title="' + colorName(x.color) + '" aria-label="' + colorName(x.color) + '"></a>';
      });
      html += '</span><span class="lm-dots__n">' + sib.length + ' colores</span>';
      el.innerHTML = html;
    });
  }
  function renderPdp(g) {
    document.querySelectorAll('[data-lm-pdp-colors]:not([data-lm-done])').forEach(function (el) {
      el.setAttribute('data-lm-done', '1');
      var s = split(el.getAttribute('data-lm-title'));
      var sib = g[s.base] || [];
      if (sib.length < 2) { el.hidden = true; return; }
      var cur = el.getAttribute('data-lm-pdp-colors');
      var label = el.querySelector('[data-lm-color-name]');
      var wrap = el.querySelector('[data-lm-color-list]');
      var html = '';
      sib.forEach(function (x) {
        var isCur = x.handle === cur;
        if (isCur && label) label.textContent = colorName(x.color);
        html += '<a href="/products/' + x.handle + '" class="lm-swatch' + (isCur ? ' is-current' : '') + (x.available ? '' : ' is-soldout') + '" title="' + colorName(x.color) + '"><span style="background:' + hexFor(x.color) + '"></span></a>';
      });
      wrap.innerHTML = html;
      el.hidden = false;
    });
  }
  function run() {
    if (!document.querySelector('[data-lm-colors]:not([data-lm-done]), [data-lm-pdp-colors]:not([data-lm-done])')) return;
    loadProducts().then(function (p) { var g = groups(p); renderCards(g); renderPdp(g); });
  }
  window.LMColors = { run: run };
  document.addEventListener('DOMContentLoaded', run);
  // tarjetas que llegan por AJAX (filtros, recomendaciones, carrito)
  new MutationObserver(function () { clearTimeout(window.__lmT); window.__lmT = setTimeout(run, 150); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();

/* 2) Carrito: "Complétalo con" agrega sin salir del carrito */
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-lm-upsell-add]');
  if (!btn) return;
  e.preventDefault();
  btn.disabled = true;
  var drawer = document.querySelector('cart-drawer');
  var body = { items: [{ id: Number(btn.getAttribute('data-lm-upsell-add')), quantity: 1 }] };
  if (drawer && drawer.getSectionsToRender) body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
  fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
    method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
  }).then(function (r) { return r.json(); }).then(function (res) {
    btn.disabled = false;
    if (res.status || !drawer) return;
    var st = res.items ? res.items[0] : res; st.sections = res.sections;
    drawer.renderContents(st);
  }).catch(function () { btn.disabled = false; });
});

/* 3) Tarjeta: botón + para productos de talla única (agrega y abre el carrito) */
document.addEventListener('submit', function (e) {
  var form = e.target.closest('.lm-card__form');
  if (!form) return;
  var drawer = document.querySelector('cart-drawer');
  if (!drawer) return;
  e.preventDefault();
  var id = form.querySelector('[name=id]').value;
  var body = { items: [{ id: Number(id), quantity: 1 }], sections: drawer.getSectionsToRender().map(function (s) { return s.id; }) };
  fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
    method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
  }).then(function (r) { return r.json(); }).then(function (res) {
    if (res.status) return;
    var st = res.items ? res.items[0] : res; st.sections = res.sections;
    drawer.renderContents(st);
  });
});

/* 4) Si el popup propio está activo, se quita el popup de la app Pop Convert (se carga por script) */
(function () {
  if (!document.getElementById('LmPopup')) return;
  function kill() { var el = document.getElementById('pop-convert-app'); if (el) el.remove(); }
  kill();
  new MutationObserver(kill).observe(document.documentElement, { childList: true, subtree: false });
  document.addEventListener('DOMContentLoaded', function () {
    kill();
    new MutationObserver(kill).observe(document.body, { childList: true });
  });
})();
